import React, { useContext, useState } from 'react';
const UserContext = /*#__PURE__*/React.createContext({
  user: {},
  setUser: user => {}
});
export const UserProvider = ({
  user: initialUser,
  children
}) => {
  const [user, setUser] = useState(initialUser || {});
  return /*#__PURE__*/React.createElement(UserContext.Provider, {
    value: {
      user,
      setUser
    }
  }, children);
};
export function useUserContext() {
  return useContext(UserContext);
}